import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export const getRelativeTimeFromNow = (timestamp: number): string => {
  return dayjs().from(dayjs(timestamp * 1000), true);
};

export const isCurrentTimeAfter = (timestamp: number): boolean => {
  return dayjs().isAfter(dayjs(timestamp * 1000));
};
